'use client'
import { TitleLoginForm } from '@/features/auth/components'
import { Stack } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { RequestResetForm, ResetPasswordForm, ResetPasswordOtpForm } from './components'

type Props = {}

export const ResetPasswordPage = (props: Props) => {
  const t = useTranslations('UserProfile')

  const [step, setStep] = useState<'REQUEST' | 'OTP' | 'RESET'>('REQUEST')
  const [email, setEmail] = useState<string>('')
  const [otp, setOtp] = useState<string>('')

  // Handlers để chuyển step với data
  const goToOtpStep = (userEmail: string) => {
    setEmail(userEmail)
    setStep('OTP')
  }

  const goToResetStep = (otp: string) => {
    setOtp(otp)
    setStep('RESET')
  }

  const goBackToRequest = () => {
    setStep('REQUEST')
    setEmail('')
  }

  return (
    <Stack
      spacing={{
        xs: 2,
        md: 3,
        lg: 4,
      }}
    >
      <TitleLoginForm
        title={
          step === 'RESET'
            ? t('Nhập mật khẩu mới cho tài khoản của bạn')
            : t('Hãy cung cấp cho chúng tôi thông tin Chúng tôi sẽ giúp bạn lấy lại tài khoản')
        }
        align="center"
      />
      {step === 'REQUEST' && <RequestResetForm onNext={goToOtpStep} />}
      {step === 'OTP' && (
        <ResetPasswordOtpForm email={email} onNext={goToResetStep} onBack={goBackToRequest} />
      )}
      {step === 'RESET' && <ResetPasswordForm email={email} otp={otp} />}
    </Stack>
  )
}
